
























































import RequestQuote from '@/components/RequestQuote.vue';
import Clinic from '@/graphql/queries/clinicWithProcedures.gql';
import ProceduresBasic from '@/graphql/queries/proceduresBasic.gql';
import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    RequestQuote,
  },
})
export default class Cart extends Vue {
  public clinic: { name: string } = { name: '' };
  public procedures: {
    [id: string]: {
      name: string;
      price: number;
      count: number;
    };
  } = {};

  public mounted() {
    if (this.$store.getters['cart/isEmpty']) {
      return;
    }

    const procedureIds = this.$store.getters['cart/procedures'];
    const procedureCounts = this.$store.getters['cart/uniqueProcedures'];

    Promise.all([
      request(Clinic, { id: this.$store.getters['cart/clinic'] }).then(
        ({ data, errors }: any) => data.clinic
      ),
      request(ProceduresBasic, { ids: Object.keys(procedureCounts) }).then(
        ({ data, errors }: any) => data.procedures
      ),
    ]).then(([clinic, procedures]: any) => {
      this.clinic = clinic;
      this.procedures = procedures.reduce(
        (o: any, p: any) => ({
          ...o,
          [p.id]: {
            ...p,
            count: procedureCounts[p.id],
            price: clinic.procedures.find((x: any) => x.procedure.id === p.id)
              .price,
          },
        }),
        {}
      );
    });
  }

  public addItem(id: string) {
    this.$store.dispatch('cart/addProcedure', id);
    this.procedures[id].price +=
      this.procedures[id].price / this.procedures[id].count;
    this.procedures[id].count++;
  }

  public removeItem(id: string) {
    this.$store.dispatch('cart/removeProcedure', id);
    if (this.procedures[id].count === 1) {
      delete this.procedures[id];
    } else {
      this.procedures[id].price -=
        this.procedures[id].price / this.procedures[id].count;
      this.procedures[id].count--;
    }
  }

  public formatPrice(price: number) {
    return (price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  public procedurePlus(procedureId: string) {
    this.$store.dispatch('cart/addProcedure', procedureId);
    this.procedures[procedureId].count++;
  }

  public procedureMinus(procedureId: string) {
    console.dir({ procedureId });
    this.$store.dispatch('cart/removeProcedure', procedureId);
    this.procedures[procedureId].count--;
    if (this.procedures[procedureId].count < 1) {
      Vue.delete(this.procedures, procedureId);
    }
  }

  public checkout() {
    // TODO: Stub
  }

  //  computed: {
  //   total: function() {
  //    return _.reduce(this.cart_items, function(n, cart_item) {
  //      return cart_item.price * cart_item.qty + n;
  //    }, 0).toFixed(2);
  //  }

  public total() {
    return Object.keys(this.procedures)
      .map(k => this.procedures[k])
      .reduce((total, p) => p.price * p.count + total, 0);
  }
}
